import React from "react";
import { useSelector } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import DateFnsUtils from "@date-io/date-fns";
import "react-image-gallery/styles/css/image-gallery.css"
import { ThemeProvider } from "styled-components/macro";
import { create } from "jss";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
  jssPreset,
} from "@material-ui/core/styles";
import "./App.css"

import createTheme from "./theme";
import Routes from "./routes/Routes";
import { AppStateType } from "./redux/reducers";
import ContextProvider from "./components/contexts";

import { I18nextProvider } from 'react-i18next';
import i18n from "../src/translations/i18n"
import { LicenseInfo } from '@mui/x-license-pro';
import ToastProvider from "./components/contexts/ToastProvider";

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point")!,
});

LicenseInfo.setLicenseKey('b697c8535fd66a28aa308c700003cb42Tz00NTY0MyxFPTE2ODY4MTg2MTQ2OTIsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

function App() {

  const theme = useSelector((state: AppStateType) => state.themeReducer);

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet
          titleTemplate="%s | Accessibility Management System"
          defaultTitle="Accessibility Management System"
        />
        <I18nextProvider i18n={i18n as any}>
          <StylesProvider jss={jss}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <MuiThemeProvider theme={createTheme(theme.currentTheme)}>
                <ThemeProvider theme={createTheme(theme.currentTheme)}>
                  <ContextProvider>
                    <ToastProvider>
                      <Routes />
                    </ToastProvider>
                  </ContextProvider>
                </ThemeProvider>
              </MuiThemeProvider>
            </MuiPickersUtilsProvider>
          </StylesProvider>
        </I18nextProvider>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
